// extracted by mini-css-extract-plugin
export default {"blankslateContainer":"blankslate-module__blankslateContainer__UPdM4Yz","blankslateContent":"blankslate-module__blankslateContent__RBkWowi"};